<template>
  <v-card>
    <v-toolbar dark color="light-blue lighten-1">
      <v-btn icon dark @click.native="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
        <v-toolbar-title>Register</v-toolbar-title>
    </v-toolbar>

    <v-divider></v-divider>

    <v-container>
        <v-form ref="form" v-model="isFormValid">
            <v-text-field
              v-model="name"
              label="Name"
              required
              :rules="nameRules"
              append-icon="mdi-account"
            ></v-text-field>
            <v-text-field
              v-model="email"
              label="E-mail"
              required
              :rules="emailRules"
              append-icon="mdi-email"
            ></v-text-field>
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              counter
              required
              :rules="passRules"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-file-input
              v-model="photoFile"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Masukkan File Foto"
              prepend-icon="mdi-camera"
              label="Photo"
              :rules="photoRules"
            ></v-file-input>

            <div class="text-xs-center">
              <v-btn
                :disabled="!isFormValid"
                color="success lighten-1"
                class="mr-4"
                @click="submit"
              >
                Register
                <v-icon right dark> mdi-lock-open </v-icon>
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                @click="reset"
              >
                Reset Form
                <v-icon right dark> mdi-refresh </v-icon>
              </v-btn>
              <v-btn
                color="warning"
                class="mr-4"
                @click="close"
              >
                Cancel
                <v-icon right dark> mdi-cancel </v-icon>
              </v-btn>
            </div>

        </v-form>
    </v-container>

  </v-card>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  data(){
    return{
      isFormValid: false,
      name: '',
      email: '',
      password: '',
      photoFile: [],
      showPassword: false,
      apiDomain: "https://demo-api-vue.sanbercloud.com",
      nameRules: [
          v => !!v || 'Nama tidak boleh kosong!',
          v => (v && v.length <= 30) || 'Nama tidak boleh lebih dari 30 karakter!',
      ],
      emailRules: [
          v => !!v || 'Email tidak boleh kosong!',
          v => /.+@.+\..+/.test(v) || 'E-mail harus valid',
      ],
      passRules: [
          v => !!v || 'Password tidak boleh kosong!',
          v => (v && v.length >= 8) || 'Password minimal 8 karakter',
      ],
      photoRules: [
        (value) => !value || value.size > 0 || 'Foto wajib diupload!',
      ]
    }
  },

  methods: {
    ...mapActions({
      setAlert : 'alert/set',
      //setToken : 'auth/setToken',
    }),

    reset(){
      this.name = '',
      this.email = '',
      this.password = '',
      this.photoFile = []
    },

    close(){
      this.$emit('closed', false)
      this.name = '',
      this.email = '',
      this.password = '',
      this.photoFile = []
    },

    submit(){

      if((this.name == '') || (this.email == '') || (this.password == '')){
        this.setAlert({
            status: true,
            color: 'error',
            text: 'Data tidak valid! Silahkan coba lagi',
        })
      }
      else{

        let formData = new FormData()
        formData.append("name", this.name)
        formData.append("email", this.email)
        formData.append("password", this.password)
        formData.append("photo_profile", this.photoFile)

        const config = {
          method: "post",
          url: this.apiDomain + "/api/v2/auth/register",
          data: formData
        }

        this.axios(config)
          .then( (response) => {
            console.log(response.data);
            this.setAlert({
                status: true,
                color: 'success',
                text: 'Anda Berhasil Registrasi!',
            })
            this.close()
          })
          .catch( (response) => {
            console.log(response)
            this.setAlert({
                status: true,
                color: 'error',
                text: 'Registrasi Gagal! Silahkan coba lagi',
            })
          })

      }

    },

  },

}
</script>
